import { z } from 'zod';
import { UUID_PATTERN } from './primitives/uuid.js';

export const PROFILE_NOTE_MAX_LENGTH = 20_000;

export const ProfileNoteParamsSchema = z.object({
  profileId: z.string().min(1, 'Profile ID is required'),
});

export const ProfileNoteIdSchema = z.string().regex(UUID_PATTERN, 'Note ID must be a valid UUID');

export const ProfileNoteSchema = z.object({
  id: ProfileNoteIdSchema,
  profileId: z.string(),
  markdown: z.string(),
  renderVersion: z.number().int().min(1),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const ProfileNoteListResponseSchema = z.object({
  notes: z.array(ProfileNoteSchema),
});

const MarkdownField = z
  .string()
  .max(PROFILE_NOTE_MAX_LENGTH, `Notes are limited to ${PROFILE_NOTE_MAX_LENGTH} characters.`);

export const ProfileNoteCreateSchema = ProfileNoteParamsSchema.extend({
  markdown: MarkdownField,
});

export const ProfileNoteUpdateSchema = ProfileNoteParamsSchema.extend({
  noteId: ProfileNoteIdSchema,
  markdown: MarkdownField,
});

export const ProfileNoteDeleteSchema = ProfileNoteParamsSchema.extend({
  noteId: ProfileNoteIdSchema,
});

export const ProfileNoteMutationResponseSchema = z.object({
  success: z.literal(true),
  note: ProfileNoteSchema,
});

export const ProfileNoteDeleteResponseSchema = z.object({
  success: z.literal(true),
});

export type ProfileNoteParams = z.infer<typeof ProfileNoteParamsSchema>;
export type ProfileNoteId = z.infer<typeof ProfileNoteIdSchema>;
export type ProfileNote = z.infer<typeof ProfileNoteSchema>;
export type ProfileNoteListResponse = z.infer<typeof ProfileNoteListResponseSchema>;
export type ProfileNoteCreate = z.infer<typeof ProfileNoteCreateSchema>;
export type ProfileNoteUpdate = z.infer<typeof ProfileNoteUpdateSchema>;
export type ProfileNoteDelete = z.infer<typeof ProfileNoteDeleteSchema>;
export type ProfileNoteMutationResponse = z.infer<typeof ProfileNoteMutationResponseSchema>;
export type ProfileNoteDeleteResponse = z.infer<typeof ProfileNoteDeleteResponseSchema>;
